import { useState } from 'react';
import Promo from '../../components/Promo/Promo';
import { CustomUserEvents, InitiatedFrom } from '../../logic/CustomUserEvents';
import { DISPATCHER_URL } from '../../utils/constants/constants';

const BlankEtaShareModule = () => {
    const [isPromoVisible, setIsPromoVisible] = useState(true);

    const _onTryDispatcherButton = () => {
        CustomUserEvents.tryDispatcherButton(InitiatedFrom.BLANK_SHARE_BUTTON);
        window.open(DISPATCHER_URL, '_blank');
    };

    return (
        <Promo
            visible={isPromoVisible}
            isShareEnabled={false}
            onTryDispatcherButton={_onTryDispatcherButton}
            onPromoVisibleChange={() => setIsPromoVisible(!isPromoVisible)}
        />
    );
};

export default BlankEtaShareModule;
